import { observable, action } from 'mobx'

class MemberManageModel {
    @observable public isImportingMemberData = false
    @observable public memberListRefreshKey = 0
    @observable public memberDetailRefreshKey = 0

    @action.bound
    public setImportingMemberData(flag: boolean) {
        this.isImportingMemberData = flag
    }

    @action.bound
    public refreshMemberList() {
        this.memberListRefreshKey += 1
    }

    @action.bound
    public refreshMemberDetail() {
        this.memberDetailRefreshKey += 1
    }
}

export const memberManageModel = new MemberManageModel()
